module.exports = __webpack_public_path__ + "img/旺旺打标6.d831b2e6.gif";